module.exports = __webpack_public_path__ + "img/ncb-gongjing-2020.de9fb783.png";